var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9958 20.4579C12.4883 20.4579 12.9001 20.0662 12.9001 19.584V12.9047H19.3887C19.8708 12.9047 20.293 12.4933 20.293 12.0009C20.293 11.5089 19.8708 11.1069 19.3887 11.1069H12.9001V4.41689C12.9001 3.93517 12.4883 3.54346 11.9958 3.54346C11.5038 3.54346 11.1018 3.93517 11.1018 4.41731V11.1073H4.61327C4.13113 11.1073 3.70898 11.5089 3.70898 12.0009C3.70898 12.4929 4.13113 12.9052 4.61327 12.9052H11.1018V19.5845C11.1018 20.0666 11.5038 20.4587 11.9958 20.4587",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLg);
export default __webpack_public_path__ + "static/media/plus-lg.ed61ecb753347f3a2be3bcf6e8162fec.svg";
export { ForwardRef as ReactComponent };